import React from 'react';
import { Button, Card, Col, Row, Space, Typography } from 'antd';
import { StepFormProps } from '../types/types';
import { useResponsive } from "../utils/use-responsive";
import { useTrackingCode } from "react-hubspot-tracking-code-hook";
import { FormPage } from "./contents/form-page";


export const LowFundingPage: React.FC<StepFormProps> = ( props ) => {
  const { setPathPageView } = useTrackingCode();
  setPathPageView("/low-funding");

  const { isMobile, isXs } = useResponsive();
  const registrationForm = JSON.parse(localStorage.getItem('pre-registration-form') || '{}');
  const companyName = registrationForm?.company?.name || '"fill Your Company Name here"';
  const registrationNumber = registrationForm?.company?.registrationNumber || '"fill Your Registration Number here"';
  const emailBody = `Hello, I am sending this email in regards to the low funding querry for Company Name: ${companyName} with Registration Number: ${registrationNumber}`;
  const mailto = `mailto:busdev@financefair.com?subject=Low Funding Application&body=${emailBody}`

  return (
    <FormPage displayFooter={true}>
      <Row justify="center">
        <Col span={20}>
          <Space direction={'vertical'} size={'large'} className={'full-width'}>
            <Card bordered={!isMobile} bodyStyle={isXs ? { padding: '0' } : { padding: '2rem' }}>
              <Space direction={"vertical"} size="large" className={'full-width'} style={{ rowGap: "0px" }}>
                <Row justify="center">
                  <Typography.Title style={{ margin: 0, textAlign: 'center', width: '100%' }} level={3}>
                    Sorry, the minimum amount we fund is <span>&#8364;</span>50,000
                  </Typography.Title>
                </Row>
                <Row justify="center" align="bottom" style={{ marginTop: '1rem' }}>
                  <Space direction={"vertical"} className={'full-width'}>
                    <Button block type="primary" size="middle"
                            data-cy="app-page-submit-button"
                            onClick={() => {
                              window.location.href = mailto
                            }}
                    >
                      Contact Us
                    </Button>
                    <Button block type="default" size="middle">
                      <a href={'https://financefair.com'}>
                        Exit
                      </a>
                    </Button>
                  </Space>
                </Row>
              </Space>
            </Card>
          </Space>
        </Col>
      </Row>
    </FormPage>
  );
};
